import Axios from 'axios';

const blobAxiosInstance = Axios.create({
  timeout: 1000 * 60 * 10, // 2 minutes
});

export default blobAxiosInstance;
